
import { isEmpty } from "../gui_components/Util.js";
import {ServiceExecutorProxy}from "./ServiceExecutorProxy.js";
export class UserService {
  constructor() {}
  static initService(appData) {
    this.sessionBean = JSON.parse(localStorage.getItem("session"));
    this.companyCode = appData.companyCode;
    this.user_data_url =
      appData.serviceURL + `/${process.env.REACT_APP_USER_SERVICE_PATH}`;
    localStorage.setItem("security_token", this.sessionBean.securityPass);
  }
  static createUser(input, responseCallBack, errorCallBack) {
    this.method("createUser", input, responseCallBack, errorCallBack);
  }
  static initUserModule(input, responseCallBack, errorCallBack) {
    this.method("initUserModule", input, responseCallBack, errorCallBack);
  }
  static unLockUser(input, responseCallBack, errorCallBack) {
    this.method("unLockUser", input, responseCallBack, errorCallBack);
  }
  static updateUser(input, responseCallBack, errorCallBack) {
    this.method("updateUser", input, responseCallBack, errorCallBack);
  }
  static getUserPageList(input, responseCallBack, errorCallBack) {
    this.method("getUserPageList", input, responseCallBack, errorCallBack);
  }
  static readUser(input, responseCallBack, errorCallBack) {
    this.method("readUser", input, responseCallBack, errorCallBack);
  }
  static getDashBoardContents(input, responseCallBack, errorCallBack) {
    this.method("getDashBoardContents", input, responseCallBack, errorCallBack);
  }

  static getDashBoardPurchaseOrderApprovalContents(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getDashBoardPurchaseOrderApprovalContents",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static getDashBoardPurchaseOrderUnApprovalContents(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getDashBoardPurchaseOrderUnApprovalContents",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static getDashBoardSalesOrderApprovalContents(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getDashBoardSalesOrderApprovalContents",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static getDashBoardSalesOrderUnApprovalContents(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getDashBoardSalesOrderUnApprovalContents",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static getDashBoardPurchaseOrderReceiptUnApprovalContents(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getDashBoardPurchaseOrderReceiptUnApprovalContents",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static getDashBoardInvoiceUnApprovalContents(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getDashBoardInvoiceUnApprovalContents",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static getDashBoardFabricStyleCurrentATSInfos(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getDashBoardFabricStyleCurrentATSInfos",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static getDashBoardLatePurchaseOrderContents(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getDashBoardLatePurchaseOrderContents",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static getDashBoardPurchaseInTransitUnApprovalContents(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getDashBoardPurchaseInTransitUnApprovalContents",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static getDashBoardLogisticOrderApprovalContents(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getDashBoardLogisticOrderApprovalContents",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getDashBoardLogisticOrderUnApprovalContents(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getDashBoardLogisticOrderUnApprovalContents",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getDashBoardLogisticOrderReceiptUnApprovalContents(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getDashBoardLogisticOrderReceiptUnApprovalContents",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static getDashBoardDueInvoiceContents(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getDashBoardDueInvoiceContents",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  
  static getDashBoardPackedAndNotInvoiceListInfos(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getDashBoardPackedAndNotInvoiceListInfos",
      input,
      responseCallBack,
      errorCallBack
    );
  }  

  static method(methodName, input, responseCallBack, errorCallBack) {
    if (isEmpty(this.sessionBean)) {
    } else if (isEmpty(this.sessionBean.securityPass)) {
    } else {
      // const isFormData = input instanceof FormData;
      // axios({
      //   method: "post",
      //   url: this.user_data_url + "/" + methodName,
      //   data: input,
      //   headers: {
      //     securitykey: localStorage.getItem("security_token"),
      //     Accept: "application/json",
      //     //"Content-Type": "application/json",
      //     ...(isFormData ? {} : { "Content-Type": "application/json" }),
      //   },
      // })
      //   .then((response) => {
      //     responseCallBack(response);
      //   })
      //   .catch((error) => {
      //     errorCallBack(error);
      //     ShowError("Erro : " + error);
      //   });
      ServiceExecutorProxy.executeService(methodName, input,this.user_data_url,responseCallBack, errorCallBack);
      
    }
  }
}
